if (!customElements.get('wr-klaviyo-explora-signup')) {
  class WrKlaviyoExploraSignup extends HTMLElement {
    constructor() {
      super();
      this.currentStep = 1;
      this.email = null;
      this.delayTimer = null;
    }

    connectedCallback() {
      this.step1Btn = this.querySelector('[data-step1-submit]');
      this.step2Btn = this.querySelector('[data-step2-submit]');
      this.step2SkipBtn = this.querySelector('[data-step2-skip]');
      //this.consentAgreeRadio = this.querySelector('[data-consent-agree]');
      //this.consentRadios = this.querySelectorAll('[name="explora_consent"]');

      this.step1Btn?.addEventListener('click', () => this.handleStep1());
      this.step2Btn?.addEventListener('click', () => this.handleStep2());
      this.step2SkipBtn?.addEventListener('click', () => this.handleStep2Skip());

      //this.consentRadios.forEach(r =>
      //  r.addEventListener('change', () => this.syncStep2SubmitState())
      //);

      this.resolveAttribution();

      const prefill = sessionStorage.getItem('explora_signup_email_prefill');
      if (prefill) {
        const emailInput = this.querySelector('[type="email"]');
        if (emailInput) emailInput.value = prefill;
        sessionStorage.removeItem('explora_signup_email_prefill');
        return;
      }

      const saved = sessionStorage.getItem('explora_signup_email');
      if (saved) {
        this.email = saved;
        this.showStep(2);
      }
    }

    disconnectedCallback() {
      clearTimeout(this.delayTimer);
    }

    showStep(n) {
      this.querySelectorAll('.wr-explora-signup__step').forEach(el => {
        el.hidden = parseInt(el.dataset.step) !== n;
      });
      this.currentStep = n;
    }

    /**
     * Route (widget / footer / minicart / …) and originating template
     * (product / collection / page / index / article …) for Klaviyo.
     * Origin points pass ?source=&source_template= — they stay in the URL,
     * so a refresh keeps them.
     */
    resolveAttribution() {
      const clean = (value) => {
        const slug = String(value || '').trim().toLowerCase();
        return /^[a-z0-9_-]{1,40}$/.test(slug) ? slug : null;
      };

      const params = new URLSearchParams(window.location.search);
      const { defaultSource, pageTemplate, inferTemplate } = this.dataset;

      this.source = clean(params.get('source')) || clean(defaultSource) || 'direct';

      this.sourceTemplate =
        clean(params.get('source_template')) ||
        (inferTemplate === 'false' ? null : this.templateFromReferrer()) ||
        clean(pageTemplate) ||
        'unknown';
    }

    /** Best-guess template from a same-origin referrer path (untagged links). */
    templateFromReferrer() {
      let referrer;
      try {
        referrer = new URL(document.referrer);
      } catch {
        return null;
      }
      if (referrer.origin !== window.location.origin) return null;
      if (referrer.pathname === window.location.pathname) return null;

      // Strip market / locale prefix, e.g. /fr or /en-us
      const path = referrer.pathname.replace(/^\/[a-z]{2}(-[a-z]{2,4})?(?=\/|$)/i, '') || '/';
      const parts = path.split('/').filter(Boolean);

      if (parts.length === 0) return 'index';
      switch (parts[0]) {
        case 'products': return 'product';
        case 'collections':
          if (parts.includes('products')) return 'product';
          return parts.length > 1 ? 'collection' : 'list-collections';
        case 'pages': return 'page';
        case 'blogs': return parts.length > 2 ? 'article' : 'blog';
        case 'search': return 'search';
        case 'cart': return 'cart';
        case 'account': return 'customers';
        default: return null;
      }
    }

    syncStep2SubmitState() {
      if (this.step2Btn) {
        this.step2Btn.disabled = !this.consentAgreeRadio?.checked;
      }
    }

    completeSignup() {
      sessionStorage.removeItem('explora_signup_email');
      const widget = document.querySelector('wr-klaviyo-signup-widget');
      if (widget?.dataset.suppressOnSignup === 'true') {
        const suppressUntil = new Date();
        suppressUntil.setFullYear(suppressUntil.getFullYear() + 1);
        window.localStorage.setItem('wr_explora_widget_suppress_until', JSON.stringify(suppressUntil.toISOString()));
      }
      this.showStep(3);
    }

    setLoading(btn, loading) {
      btn.setAttribute('aria-busy', loading ? 'true' : 'false');
      btn.disabled = loading;
    }

    /**
     * Klaviyo requires E.164 (e.g. +447700900123).
     * Normalises common UK formats; returns null if it can't.
     */
    formatPhoneForKlaviyo(raw) {
      if (!raw) return null;

      let cleaned = String(raw).trim().replace(/[\s().-]/g, '');

      if (cleaned.startsWith('00')) {
        cleaned = `+${cleaned.slice(2)}`;
      } else if (cleaned.startsWith('+')) {
        // already international
      } else if (cleaned.startsWith('0')) {
        cleaned = `+44${cleaned.slice(1)}`;
      } else if (/^44\d+$/.test(cleaned)) {
        cleaned = `+${cleaned}`;
      } else if (/^\d{10,15}$/.test(cleaned)) {
        cleaned = `+44${cleaned}`;
      }

      cleaned = `+${cleaned.replace(/\D/g, '')}`;

      return /^\+[1-9]\d{6,14}$/.test(cleaned) ? cleaned : null;
    }

    async handleStep1() {
      const firstNameInput = this.querySelector('[name="first_name"]');
      const lastNameInput = this.querySelector('[name="last_name"]');
      const emailInput = this.querySelector('[type="email"]');
      const phoneInput = this.querySelector('[name="phone"]');
      const gdprInput = this.querySelector('[name="gdpr"]');
      const firstNameErr = this.querySelector('[id^="ExploraFirstNameError"]');
      const lastNameErr = this.querySelector('[id^="ExploraLastNameError"]');
      const emailErr = this.querySelector('[id^="ExploraEmailError"]');
      const gdprErr = this.querySelector('[id^="ExploraGdprError"]');
      const apiErr = this.querySelector('[id^="ExploraApiError1"]');

      if (firstNameErr) firstNameErr.hidden = true;
      if (lastNameErr) lastNameErr.hidden = true;
      if (emailErr) emailErr.hidden = true;
      if (gdprErr) gdprErr.hidden = true;
      if (apiErr) apiErr.hidden = true;

      let valid = true;
      let focusTarget = null;

      if (!firstNameInput || !firstNameInput.value.trim()) {
        if (firstNameErr) firstNameErr.hidden = false;
        focusTarget = firstNameInput;
        valid = false;
      }

      if (!lastNameInput || !lastNameInput.value.trim()) {
        if (lastNameErr) lastNameErr.hidden = false;
        if (!focusTarget) focusTarget = lastNameInput;
        valid = false;
      }

      if (!emailInput?.checkValidity()) {
        if (emailErr) emailErr.hidden = false;
        if (!focusTarget) focusTarget = emailInput;
        valid = false;
      }

      if (gdprInput && !gdprInput.checked) {
        if (gdprErr) gdprErr.hidden = false;
        if (!focusTarget) focusTarget = gdprInput;
        valid = false;
      }

      if (!valid) {
        focusTarget?.focus();
        return;
      }

      // Theme editor: skip Klaviyo so merchants can preview the multi-step UI
      if (typeof Shopify !== 'undefined' && Shopify.designMode) {
        this.email = emailInput.value.trim();
        this.showStep(2);
        return;
      }

      const { companyId, listId, customSource, appendSource } = this.dataset;

      if (!companyId || !listId) {
        if (apiErr) apiErr.hidden = false;
        return;
      }

      const profileAttributes = {
        email: emailInput.value.trim(),
        first_name: firstNameInput.value.trim(),
        last_name: lastNameInput.value.trim(),
        subscriptions: {
          email: { marketing: { consent: 'SUBSCRIBED' } }
        },
        properties: {
          explora_signup_source: this.source,
          explora_signup_template: this.sourceTemplate
        }
      };

      const phoneRaw = phoneInput?.value.trim();
      if (phoneRaw) {
        const phoneE164 = this.formatPhoneForKlaviyo(phoneRaw);
        if (phoneE164) {
          profileAttributes.phone_number = phoneE164;
        }
        // Always keep the raw entry so nothing is lost if formatting fails
        profileAttributes.properties.explora_contact_number = phoneRaw;
      }

      let subscriptionSource = customSource || 'Explora Club Theme Signup';
      if (appendSource === 'true') {
        subscriptionSource = `${subscriptionSource} – ${this.source}`;
      }

      this.setLoading(this.step1Btn, true);

      try {
        const res = await fetch(
          `https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(companyId)}`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'revision': '2025-01-15'
            },
            body: JSON.stringify({
              data: {
                type: 'subscription',
                attributes: {
                  custom_source: subscriptionSource,
                  profile: {
                    data: {
                      type: 'profile',
                      attributes: profileAttributes
                    }
                  }
                },
                relationships: {
                  list: { data: { type: 'list', id: listId } }
                }
              }
            })
          }
        );

        if (res.status === 202) {
          this.email = emailInput.value.trim();
          sessionStorage.setItem('explora_signup_email', this.email);
          this.showStep(2);
        } else {
          if (apiErr) apiErr.hidden = false;
        }
      } catch {
        if (apiErr) apiErr.hidden = false;
      } finally {
        this.setLoading(this.step1Btn, false);
      }
    }

    async handleStep2() {
      //consent check removed as checkbox removed
      const apiErr = this.querySelector('[id^="ExploraApiError2"]');
      if (apiErr) apiErr.hidden = true;

      // Theme editor: skip Klaviyo and show success
      if (typeof Shopify !== 'undefined' && Shopify.designMode) {
        this.completeSignup();
        return;
      }

      const { companyId } = this.dataset;
      const interests = Array.from(
        this.querySelectorAll('[name="interests"]:checked')
      ).map(cb => cb.value);

      // Attribution (explora_signup_source / _template) is sent in step 1 so it survives a skip
      const properties = {
        explora_personalised_comms_consent: true
      };
      if (interests.length > 0) {
        properties.explora_interests = interests;
      }

      this.setLoading(this.step2Btn, true);

      try {
        const res = await fetch(
          `https://a.klaviyo.com/client/profiles/?company_id=${encodeURIComponent(companyId)}`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'revision': '2025-01-15'
            },
            body: JSON.stringify({
              data: {
                type: 'profile',
                attributes: {
                  email: this.email,
                  properties
                }
              }
            })
          }
        );

        if (res.status === 202) {
          this.completeSignup();
        } else {
          if (apiErr) apiErr.hidden = false;
        }
      } catch {
        if (apiErr) apiErr.hidden = false;
      } finally {
        this.setLoading(this.step2Btn, false);
      }
    }

    handleStep2Skip() {
      const consentErr = this.querySelector('[id^="ExploraConsentError"]');
      const apiErr = this.querySelector('[id^="ExploraApiError2"]');

      if (consentErr) consentErr.hidden = true;
      if (apiErr) apiErr.hidden = true;

      this.completeSignup();
    }
  }

  customElements.define('wr-klaviyo-explora-signup', WrKlaviyoExploraSignup);
}
